const Icon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.9248 23.8186C44.3107 23.1861 44.3149 22.1631 42.9248 21.5292L5.28 4.35407C3.894 3.72157 2.76925 4.44757 2.7665 5.95045L2.75 18.3475L33.2393 22.6732L2.75 26.9989L2.7665 39.3973C2.76925 40.9112 3.88987 41.6276 5.28 40.9937L42.9248 23.8186Z"
      fill="#B1B1B1"
    />
  </svg>
);

export default Icon;
